export abstract class Base {
    protected constructor(data = {}) {
        Object.keys(data).forEach((key) => {
            if (this.hasOwnProperty(key)) {
                this[key] = data[key];
            }
        });
    }
}
